import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import SessionConfig from "../../config/session_config"
import { useTranslation } from "react-i18next"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DataTable from "react-data-table-component"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
} from "reactstrap"
import showToast from "../../components/Common/viewNotification"
import { is_empty } from "../../config/validate"
import ConceptForm from "./conceptForm"
import TypeConcept from "./TypeConcept"
import {
  initLoadConcepts,
  initDeleteConcepts,
  cleanConcept,
} from "../../store/actions"
const Concept = () => {
  const dispatch = useDispatch()
  const ref = useRef()

  const { t } = useTranslation()
  const [columns, setColumns] = useState([])
  const [selectRows, setSelectRows] = useState([])
  const [toggleSwitch, settoggleSwitch] = useState(true)
  const [clearSelectedRows, setclearSelectedRows] = useState(false)
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [currentConcept, setCurrentConcept] = useState(null)
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))

  // header title
  document.title = t("concept:title") + " | " + t("global:title")
  //#region  store
  const { concepts, loading, error, conceptsDelete } = useSelector(state => ({
    loading: state.Concept.loading,
    concepts: state.Concept.concepts,
    error: state.Concept.error,
    conceptsDelete: state.Concept.conceptsDelete,
  }))
  //#endregion
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
      dispatch(cleanConcept())
    }
  }, [error])
  useEffect(() => {
    if (conceptsDelete?.response?.length > 0) {
      setSelectRows([])

      showToast(t("concept:msmdisable"), "success", t("concept:title"))
      loadData()
    }
  }, [conceptsDelete])
  useEffect(() => {
    document.getElementById("body").className = "backPage"
  }, [])
  useEffect(() => {
    loadData()
  }, [toggleSwitch])
  //#region funciones
  const loadData = async () => {
    initColumns()
    await dispatch(initLoadConcepts(toggleSwitch ? 1 : 0))
  }
  const initColumns = () => {
    let col = [
      {
        name: "",
        // eslint-disable-next-line react/display-name
        cell: row => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="mdi mdi-cog font-size-18"
                id="edittooltip"
                onClick={() => conceptEdit(row)}
              ></i>
            </Link>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        width: "80px",
      },
      {
        name: t("concept:name"),
        sortable: false,
        wrap: true,
        width: "30%",
        // eslint-disable-next-line react/display-name
        cell: row => (
          <span>
            <h5 className="font-size-14 mb-1">
              <Link
                to="#"
                className="text-dark"
                onClick={() => conceptEdit(row)}
              >
                {row.name}
              </Link>
            </h5>
          </span>
        ),
      },
      {
        name: t("concept:code"),
        sortable: false,
        wrap: true,
        width: "30%",
        // eslint-disable-next-line react/display-name
        cell: row => (
          <span>
            <div className="text-primary text-capitalize">{row.code}</div>
          </span>
        ),
      },
      {
        name: t("concept:state"),
        sortable: false,
        wrap: true,
        width: "80px",
        omit: toggleSwitch,
        // eslint-disable-next-line react/display-name
        cell: row => (
          <>
            <span
              to="#"
              className={
                row.status === 1
                  ? "badge badge-soft-primary font-size-11 m-1"
                  : "badge badge-soft-danger font-size-11 m-1"
              }
            >
              {row.status === 1 ? t("global:active") : t("global:disable")}
            </span>
          </>
        ),
      },
    ]
    setColumns(col)
  }
  const toggle = () => {
    setModal(!modal)
  }
  const conceptAdd = () => {
    setIsEdit(false)
    setCurrentConcept(null)
    toggle()
  }
  const conceptEdit = row => {
    setIsEdit(true)
    setCurrentConcept(row)
  }

  const handleRowSelected = React.useCallback(state => {
    setSelectRows(state.selectedRows)
  }, [])

  const conceptDisable = async () => {
    const ls = {
      createdBy: auth.id.user.username,
      rows: selectRows,
    }
    setclearSelectedRows(true)
    await dispatch(initDeleteConcepts(ls))
    setclearSelectedRows(false)
  }
  //#endregion
  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("concept:title")}
          />
          {!currentConcept ? (
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <Row>
                      <Col>
                        <div className="form-check form-switch mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitch2"
                            defaultChecked={toggleSwitch}
                            onClick={e => {
                              settoggleSwitch(e?.target?.checked)
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customSwitch2"
                          >
                            {t("concept:noInactive")}
                          </label>
                        </div>
                      </Col>
                      <Col>
                        <div className="text-sm-end">
                          <ButtonGroup>
                            <Button color="danger" onClick={conceptDisable}>
                              <i className=" fas fa-times-circle me-1 " />
                              {t("global:setdisabled")}
                            </Button>

                            <Button
                              color="primary"
                              className="font-16 btn-block btn btn-primary"
                              onClick={conceptAdd}
                            >
                              <i className="fas fa-plus-circle me-1" />
                              {t("global:add")}
                            </Button>
                          </ButtonGroup>
                        </div>
                      </Col>
                    </Row>
                    <DataTable
                      columns={columns}
                      data={concepts}
                      fixedHeader
                      fixedHeaderScrollHeight="500px"
                      dense
                      selectableRows={toggleSwitch}
                      onSelectedRowsChange={handleRowSelected}
                      highlightOnHover
                      pagination
                      progressPending={loading}
                      progressComponent={<LinearIndeterminate />}
                      clearSelectedRows={clearSelectedRows}
                      noDataComponent={t("tableOptions:noDataComponent")}
                      paginationComponentOptions={{
                        rowsPerPageText: t("tableOptions:rowsPerPageText"),
                        rangeSeparatorText: t(
                          "tableOptions:rangeSeparatorText"
                        ),
                        selectAllRowsItem: true,
                        selectAllRowsItemText: t(
                          "tableOptions:selectAllRowsItemText"
                        ),
                      }}
                    />
                    <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
                      <ModalHeader toggle={toggle} tag="h4"  close={<span></span>}>
                        {t("concept:add")}
                      </ModalHeader>
                      <ModalBody>
                        <ConceptForm
                          onClosing={toggle}
                          isEdit={false}
                          currentConcept={null}
                          onLoad={loadData}
                        />
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xl="3">
                <Card>
                  <CardBody>
                    <CardTitle tag="h5" className="text-primary text-uppercase">
                      <i className="mdi mdi-cog font-size-18" />
                      {t("global:config")}
                      <hr />
                    </CardTitle>
                    <ConceptForm
                      onClean={() => {
                        setCurrentConcept(null)
                      }}
                      isEdit={true}
                      currentConcept={currentConcept}
                      onLoad={loadData}
                    />
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <TypeConcept currentConcept={currentConcept} />
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}
export default Concept
